import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecruiterNavbarComponent } from '../../components/navbar/recruiter-navbar.component';
import { RecruiterHeroComponent } from '../../components/hero/recruiter-hero.component';
import { RecruiterTrustedCompaniesComponent } from '../../components/trusted-companies/recruiter-trusted-companies.component';
import { RecruiterStatsComponent } from '../../components/stats/recruiter-stats.component';
import { RecruiterWhyBeexpertComponent } from '../../components/why-beexpert/recruiter-why-beexpert.component';
import { RecruiterHiringProcessComponent } from '../../components/hiring-process/recruiter-hiring-process.component';
import { RecruiterFeaturesComponent } from '../../components/features/recruiter-features.component';
import { RecruiterHiringSolutionsComponent } from '../../components/hiring-solutions/recruiter-hiring-solutions.component';
import { RecruiterTestimonialsComponent } from '../../components/testimonials/recruiter-testimonials.component';
import { RecruiterCtaComponent } from '../../components/cta/recruiter-cta.component';
import { RecruiterFooterComponent } from '../../components/footer/recruiter-footer.component';
// import { FloatingWhatsappComponent } from '../../../../shared/components/floating-whatsapp/floating-whatsapp.component';

@Component({
  selector: 'app-recruiter-landing',
  standalone: true,
  imports: [
    CommonModule,
    RecruiterNavbarComponent,
    RecruiterHeroComponent,
    RecruiterTrustedCompaniesComponent,
    RecruiterStatsComponent,
    RecruiterWhyBeexpertComponent,
    RecruiterHiringProcessComponent,
    RecruiterFeaturesComponent,
    RecruiterHiringSolutionsComponent,
    RecruiterTestimonialsComponent,
    RecruiterCtaComponent,
    RecruiterFooterComponent,
    // FloatingWhatsappComponent
  ],
  templateUrl: './recruiter-landing.component.html',
  styleUrls: ['./recruiter-landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecruiterLandingComponent { }
